export const normalizeSearchText = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()
    .replace(/\s+/g, " ");

export const matchesSearch = (item, query, fields = ["name", "title"]) => {
  const terms = normalizeSearchText(query).split(" ").filter(Boolean);
  if (!terms.length) return true;

  const searchableText = normalizeSearchText(
    fields.map((field) => item?.[field] ?? "").join(" "),
  );

  return terms.every((term) => searchableText.includes(term));
};

// Use one punctuation-free term for APIs that treat characters such as "-"
// literally. The complete query is still applied by matchesSearch in the UI.
export const getSearchProbe = (query) =>
  normalizeSearchText(query)
    .split(" ")
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)[0] || "";
